var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMissionPositionStorage } from '../../../../ui/hooks';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import React from 'react';
import useSWR from 'swr';
export const missionPositionsForShiftFetchKey = 'missionPositionsForShift';
export function useMissionPositionsForShift({ positionIds }) {
    var _a;
    const positionStorage = useMissionPositionStorage();
    const fetchMissionPositions = (positionIds) => __awaiter(this, void 0, void 0, function* () {
        return yield positionStorage.list({
            filter: [
                {
                    op: 'in',
                    id: positionIds,
                },
            ],
        });
    });
    const { data, mutate, isLoading, error } = useSWR([missionPositionsForShiftFetchKey, positionIds], ([, paramsPositionIds]) => {
        return fetchMissionPositions(paramsPositionIds).catch(handleErrorSnackbar);
    }, defaultFetcherOptions);
    const fetchAnalytics = React.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        fetchAnalytics,
        data: (_a = data === null || data === void 0 ? void 0 : data.rows) !== null && _a !== void 0 ? _a : [],
        error,
        isLoading,
    };
}
